import { Clear } from '@mui/icons-material';
import { Box, IconButton, MenuItem } from '@mui/material';
import StyledTextField from './styled/StyledTextField';

type Props = {
  label: string;
  options: string[];
  value: string;
  setValue: (value: string) => void;
  renderOption?: (option: string) => string;
};

const FilterDropdown = ({ options, value, setValue, label, renderOption }: Props) => (
  <Box sx={{ display: 'flex', gap: 0.5 }}>
    <StyledTextField
      select
      label={label}
      value={value}
      size="small"
      sx={{ width: 202 }}
      onChange={(e) => setValue(e.target.value)}
    >
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {renderOption ? renderOption(option) : option}
        </MenuItem>
      ))}
    </StyledTextField>

    {value && (
      <IconButton onClick={() => setValue('')}>
        <Clear />
      </IconButton>
    )}
  </Box>
);

export default FilterDropdown;
